module.exports = __webpack_public_path__ + "static/media/legal-pilot.8ed92b40.svg";